module.exports = __webpack_public_path__ + "static/img/img2.d334ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2.png
// module id = fhjV
// module chunks = 1